import React from 'react';
import PropTypes from 'prop-types';

import {
    black100,
    black400,
    black500,
    grey200,
    grey300,
    greyishBlue200
} from "assets/jss/main";

import Badge from "components/Badge";

import {UserAgentUtils} from "utils/useragent";

ClickableChip.propTypes = {
    checked: PropTypes.bool,
    count: PropTypes.number,
    label: PropTypes.any,
    icon: PropTypes.element,
    onClick: PropTypes.func,
    round: PropTypes.bool,
    style: PropTypes.object,
    fullWidth: PropTypes.bool,
};

function ClickableChip({
    checked,
    count,
    label,
    icon,
    onClick,
    style,
    noWrapText =  false,
    round = true,
    large = false,
    thick = false,
    fullWidth = false,
    ...props
}) {
    return (
        <div
            style={{
                fontSize: '14px',
                fontWeight: 600,
                color: checked ? black500 : black400,
                border: `1px solid ${checked ? greyishBlue200 : grey300}`,
                background: checked ? '#fff' : grey200,
                padding: UserAgentUtils.isMobile() ? '8px' : '12px 16px',
                borderRadius: round ? '48px' : '8px',
                cursor: 'pointer',
                height: thick ? '48px' : '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: (large || fullWidth) ? 'center' : "",
                width: large ? '172px' : fullWidth ? '100%' : 'fit-content',
                textWrap: noWrapText ? 'nowrap' : 'inherit',
                ...style
            }}
            onClick={onClick}
        >
            {icon && (
                <div style={{
                    marginRight: '8px',
                    height: '16px',
                    width: '16px',
                }}>
                    {icon}
                </div>
            )}
            <span>{label || props.children}</span>
            {!isNaN(count) && (
                <div style={{marginLeft: '8px'}}>
                    <Badge
                        backgroundColor={checked ? black500 : black100}
                        labelColor={checked ? '#FFFFFF' : black400}
                    >
                        {count}
                    </Badge>
                </div>
            )}
        </div>
    );
}

export default ClickableChip;
